import styled from 'styled-components'

const EventsStyle = styled.div`
	--mainContainerPaddingTop: var(--sp13x);
	--selectOuterTextMarginRight: var(--sp15x);
	--arrowPosition: calc(var(--sp10x) * -1);
	--arrowSize: var(--sp5x);
	--eventItemsWrap: calc(var(--sp8x) - var(--itemMarginTop));
	--itemMarginTop: var(--sp5x);
	--loadBtnMargin: var(--sp8x) auto 0;
	--loadBtnPadding: var(--sp2x) var(--sp5x);
	--loadBtnBorderRadius: var(--sp2x);

	.main-container {
		padding-top: var(--mainContainerPaddingTop);
	}

	.load-btn {
		display: flex;
		width: fit-content;
		margin: var(--loadBtnMargin);
		padding: var(--loadBtnPadding);
		border: 1px solid var(--primaryColor1);
		border-radius: var(--loadBtnBorderRadius);
		cursor: pointer;
		transition: var(--trTime);

		@media (hover: hover) {
			&:hover {
				background-color: var(--primaryColor1);
				color: var(--primaryColor3);
			}
		}
	}

	.event-page-items-wrap {
		margin-top: var(--eventItemsWrap);

		.event-page-item {
			margin-top: var(--itemMarginTop);
		}
	}

	.articles-page-items-wrap {
		margin-top: calc(var(--eventItemsWrap) + var(--itemMarginTop));
	}

	.page-top {
		display: flex;
		align-items: center;

		.select-outer-text {
			margin-right: var(--selectOuterTextMarginRight);
		}

		.page-top-select {
			max-width: fit-content;
			z-index: 1;
		}

		.ant-select {
			.ant-select-selector {
				background-color: unset;
				padding: 0;
				font-size: 16px;

				.ant-select-selection-item {
					font-size: ping;
					font-weight: 700;
					font-size: var(--h3);
					color: var(--secondaryColor2);
					text-decoration: underline;
					overflow: visible;
				}
			}
			.ant-select-arrow {
				right: unset;
				left: var(--arrowPosition);

				.select-arrow {
					font-size: var(--arrowSize);
					color: var(--secondaryColor2);
					transform: rotate(90deg);
				}
			}
		}

		.select-wrap {
			.ant-select-dropdown {
				width: fit-content !important;
			}

			.ant-select-item-option {
				font-size: var(--p);
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--mainContainerPaddingTop: var(--sp10x);
		--selectOuterTextMarginRight: var(--sp10x);
		--arrowPosition: calc(var(--sp7x) * -1);
		--arrowSize: var(--sp4x);
		--itemMarginTop: var(--sp4x);
		--eventItemsWrap: calc(var(--sp7x) - var(--itemMarginTop));
		--loadBtnMargin: var(--sp7x) auto 0;
		--loadBtnPadding: var(--sp2x) var(--sp4x);
		--loadBtnBorderRadius: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--mainContainerPaddingTop: var(--sp8x);
		--selectOuterTextMarginRight: var(--sp10x);
		--arrowPosition: calc(var(--sp7x) * -1);
		--arrowSize: var(--sp4x);
		--itemMarginTop: var(--sp3x);
		--eventItemsWrap: calc(var(--sp4x) - var(--itemMarginTop));
		--loadBtnMargin: var(--sp6x) auto 0;
		--loadBtnPadding: var(--sp1-5x) var(--sp3x);
		--loadBtnBorderRadius: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--mainContainerPaddingTop: var(--sp8x);
		--selectOuterTextMarginRight: var(--sp7x);
		--arrowPosition: calc(var(--sp5x) * -1);
		--arrowSize: var(--sp3x);
		--itemMarginTop: var(--sp3x);
		--eventItemsWrap: calc(var(--sp4x) - var(--itemMarginTop));
		--loadBtnMargin: var(--sp6x) auto 0;
		--loadBtnPadding: var(--sp1-5x) var(--sp3x);
		--loadBtnBorderRadius: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--mainContainerPaddingTop: var(--sp7x);
		--selectOuterTextMarginRight: var(--sp7x);
		--arrowPosition: calc(var(--sp5x) * -1);
		--arrowSize: var(--sp3x);
		--itemMarginTop: var(--sp3x);
		--eventItemsWrap: calc(var(--sp4x) - var(--itemMarginTop));
		--loadBtnMargin: var(--sp5x) auto 0;
		--loadBtnPadding: var(--sp1-5x) var(--sp3x);
		--loadBtnBorderRadius: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--mainContainerPaddingTop: var(--sp5x);
		--selectOuterTextMarginRight: var(--sp6x);
		--arrowPosition: calc(var(--sp4x) * -1);
		--arrowSize: var(--sp2x);
		--itemMarginTop: var(--sp2x);
		--eventItemsWrap: calc(var(--sp3x) - var(--itemMarginTop));
		--loadBtnMargin: var(--sp5x) auto 0;
		--loadBtnPadding: var(--sp1-5x) var(--sp3x);
		--loadBtnBorderRadius: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--mainContainerPaddingTop: var(--sp5x);
		--selectOuterTextMarginRight: var(--sp6x);
		--arrowPosition: calc(var(--sp4x) * -1);
		--arrowSize: var(--sp2x);
		--itemMarginTop: var(--sp2x);
		--eventItemsWrap: calc(var(--sp3x) - var(--itemMarginTop));
		--loadBtnMargin: var(--sp5x) auto 0;
		--loadBtnPadding: var(--sp1-5x) var(--sp3x);
		--loadBtnBorderRadius: var(--sp1x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--mainContainerPaddingTop: var(--sp5x);
		--selectOuterTextMarginRight: 0;
		--arrowPosition: calc(var(--sp4x) * -1);
		--arrowSize: var(--sp2x);
		--itemMarginTop: var(--sp5x);
		--eventItemsWrap: calc(var(--sp1x) * -1);
		--loadBtnMargin: var(--sp5x) auto 0;
		--loadBtnPadding: var(--sp1-5x) var(--sp3x);
		--loadBtnBorderRadius: var(--sp1x);

		.main-container {
			.page-top {
				flex-direction: column;
				align-items: unset;

				.page-top-select {
					margin: var(--sp3x) 0 0 var(--sp4x);
				}
			}
		}

		.filter-first-line {
			.ant-picker-panels {
				flex-direction: column;
			}
		}
	}
`

export default EventsStyle
